import Rest from '@services/Rest';

/**
 * @typedef {AdjustSale}
 */
export default class AdjustSale extends Rest {
  /**
   * @type {String}
   */
  static resource = '/admin/adjust-sale'
}
